"use client";

import "swiper/css";
import "swiper/css/autoplay";
import dynamic from "next/dynamic";
import styles from "./career-insights.module.scss";
const TestimonialSlider = dynamic(() => import("./career-slider"), { ssr: true });

interface CareerInsightsProps {
  data?: any;
  isMobile?: boolean;
}

const CareerInsights = ({ data }: CareerInsightsProps) => {
  return (
    <>
      <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
        <div className="container">
          <div
            className={`${styles.headingCareer} mb-[32px] lg:mb-[32px] xl:mb-[40px] `}
          >
            <h2 className="text-center font-bold text-primary-text text-heading-1">
              {data?.title}
            </h2>
            <p className="text-[#32343B] text-subtitle-3 text-center">
              {data?.sub_title}
            </p>
          </div>

          <TestimonialSlider data={data?.testimonialCards ?? []} />
        </div>
      </section>
    </>
  );
};
export default CareerInsights;
